/**
 * ブラウザへ配信される設定値。
 *
 * ここに service role key のような秘密情報を置いてはならない (SPEC 64)。
 * Vite は `VITE_` 接頭辞の変数だけをバンドルへ入れるので、
 * 接頭辞なしの秘密情報が混入する経路は構造的に存在しない。
 */
function required(name: string, value: string | undefined): string {
  if (!value) {
    // ビルド時ではなく起動時に落とす。設定漏れに気づかず動き続けるより良い。
    throw new Error(`環境変数 ${name} が設定されていません`);
  }
  return value;
}

export const env = {
  supabaseUrl: required('VITE_SUPABASE_URL', import.meta.env['VITE_SUPABASE_URL']),
  supabaseAnonKey: required('VITE_SUPABASE_ANON_KEY', import.meta.env['VITE_SUPABASE_ANON_KEY']),
  apiUrl: (import.meta.env['VITE_API_URL'] ?? 'http://127.0.0.1:3001').replace(/\/$/, ''),
} as const;
